import { Component } from '@angular/core';

import { ActivityRoutineProvider } from '../../providers/providers';

@Component({
  selector: 'page-activity-routine-list',
  templateUrl: 'activity-routine-list.html',
})
export class ActivityRoutineListPage {
  activityRoutineList: any = [];
  isLoaded: boolean = false;

  constructor(
    private activityRoutineProvider: ActivityRoutineProvider) {
  }

  ionViewDidLoad() {
    this.loadView();
  }

  loadView() {
    this.activityRoutineProvider.Load().then((items: any[]) => {
      items.map(item => {
        item.showDetails = false;
        item.icon = 'arrow-dropdown';
      });
      this.activityRoutineList = items;
      this.isLoaded = true;
    });
  }

  toggleDetails(item) {
    if (item.showDetails) {
      item.showDetails = false;
      item.icon = 'arrow-dropdown';
    }
    else {
      item.showDetails = true;
      item.icon = 'arrow-dropup';
    }  
  }
}


// WEBPACK FOOTER //
// ./src/pages/exercises/activity-routine-list.ts